import React from 'react';

import classes from './Button.module.css';
import { IsStringEmpty } from '../../../utilities/CommonMethods';


/* 
Available props classes:
BorderButton, BorderButtonBlue, DarkBlue, TextOnlyButton, TextOnlyButtonDark, TextOnlyButtonBlue, RoundSquareCorners, Disabled, EnterpriseSubscribeButton, WatchNowButton,
TextOnlyButtonDark, TextOnlyButtonBlue, GoToCourseButton, GoToCourseButtonBlue, TextOnlyCommentButtonDark, TextOnlyCommentButtonBlue, 
MobileOnly, NonMobileOnly, NonMobileOnlyFeedback, MobileOnlyFeedback, RoundSquareCorners, Disabled, EnterpriseSubscribeButton, QuizSubmitButton,NoticeBoardCardButton
*/
const button = (props) => {
    let stylesClasses = [classes.Button];

    if (props.styleclass !== undefined) {
        const styleClasses = props.styleclass.split(' ');
        for (let style in styleClasses) {
            stylesClasses.push(classes[styleClasses[style].trim()]);
        }
    }

    if (props.disabled === true) {
        stylesClasses.push(classes.Disabled);
    }

    const width = props.width ? props.width : 'auto';
    const height = props.height ? props.height : '';
    const fontSize = !IsStringEmpty(props.fontSize) ? props.fontSize : '0.875em';
    const padding = props.padding ? props.padding : '0.5em 2em';
    const margin = props.margin ? props.margin : '0px 1em 0px 0px'; //Pass margin as single props.

    return (
        <button
            className={stylesClasses.join(' ')}
            disabled={props.disabled === true}
            onClick={props.clicked}
            title={props.tooltip}
            style={!IsStringEmpty(height)
                ? { width: width, height: height, fontSize: fontSize, padding: padding, margin: margin }
                : { width: width, fontSize: fontSize, padding: padding, margin: margin }
            }>
            {props.label}
        </button>
    );
}

export default button;